<div *ngIf="loader; else elseBlock" class="spinner">
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>

<ng-template #elseBlock>
  <div class="divHome">
    <h2>Asignar Equipos</h2>

    <div class="divButtons">
      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>Files</mat-label>
        <mat-select
          [formControl]="toppings"
          (selectionChange)="applyFilterSelect()"
        >
          <mat-option value="{{ null }}">Todos los Files</mat-option>
          <mat-option *ngFor="let topping of arrayFiles" [value]="topping">{{
            topping
          }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>CLIENTE </mat-label>
        <mat-select
          [(value)]="selectClient"
          (selectionChange)="applyFilterSelect()"
        >
          <mat-option value="{{ null }}">No seleccionar</mat-option>
          <mat-option
            *ngFor="let client of arrayClients"
            value="{{ client }}"
            >{{ client }}</mat-option
          >
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>ESTADO FILE </mat-label>
        <mat-select
          [(value)]="selectEstadoFile"
          (selectionChange)="applyFilterSelect()"
        >
          <mat-option value="{{ null }}">No seleccionar</mat-option>
          <mat-option
            *ngFor="let estadoFile of arrayEstadoFile"
            value="{{ estadoFile }}"
            >{{ estadoFile }}</mat-option
          >
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>DAY</mat-label>
        <mat-select
          [(value)]="daySelected"
          (selectionChange)="applyFilterSelect()"
        >
          <mat-option value="{{ null }}">No seleccionar</mat-option>
          <mat-option *ngFor="let agencia of arrayDays" value="{{ agencia }}">{{
            agencia
          }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>TIPO SERVICIO</mat-label>
        <mat-select
          [(value)]="typeOfServiceSelected"
          (selectionChange)="applyFilterSelect()"
        >
          <mat-option value="{{ null }}">No seleccionar</mat-option>
          <mat-option
            *ngFor="let file of arrayTypesOfService"
            value="{{ file }}"
            >{{ file }}</mat-option
          >
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>SERVICIO </mat-label>
        <mat-select
          [(value)]="selectService"
          (selectionChange)="applyFilterSelect()"
        >
          <mat-option value="{{ null }}">No seleccionar</mat-option>
          <mat-option
            *ngFor="let service of arrayServices"
            value="{{ service }}"
            >{{ service }}</mat-option
          >
        </mat-select>
      </mat-form-field>
    </div>

    <div style="display: flex; justify-content: center; margin-top: 1rem">
      <mat-form-field appearance="outline" class="divInputSearch">
        <input matInput (keyup)="applyFilter($event)" placeholder="Buscar" />
      </mat-form-field>
    </div>

    <div style="display: flex; justify-content: space-between; flex-wrap: wrap">
      <mat-card
        *ngIf="toppings.value"
        style="margin-bottom: 2rem; width: 30rem"
      >
        <mat-card-title>File {{ toppings.value }}</mat-card-title>
        <mat-card-content style="font-weight: bold">Guías:</mat-card-content>
        <div *ngFor="let guia of fileGuias">
          <mat-card-content>- {{ guia.objProvider.nombre }}</mat-card-content>
        </div>
      </mat-card>

      <div
        *ngIf="estadoBtnEquipos"
        style="
          display: flex;
          justify-content: end;
          gap: 20px;
          margin-top: 2rem;
          margin-bottom: 2rem;
          align-items: end;
        "
      >
        <button
          mat-raised-button
          class="buttonPrimary"
          (click)="openDialogAsignarEquipos()"
        >
          Asignar Equipos
        </button>

        <button
          mat-raised-button
          class="buttonPrimary"
          (click)="openDialogVerEquipos()"
        >
          Ver Equipos Asignados
        </button>
      </div>
    </div>

    <div class="example-container mat-elevation-z8" *ngIf="fileDataSource">
      <mat-table [dataSource]="fileDataSource" matSort>
        <ng-container matColumnDef="day">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            DAY
          </mat-header-cell>
          <mat-cell *matCellDef="let row"> {{ row.day }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="fileName">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            CLIENTE
          </mat-header-cell>
          <mat-cell *matCellDef="let row"> {{ row.fileName }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="estadoFile">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            ESTADO FILE
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            {{ row.estadoFile ? row.estadoFile : row.estado }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="fileNumber">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            FILE
          </mat-header-cell>
          <mat-cell *matCellDef="let row"> {{ row.fileNumber }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="date">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            FECHA SERVICIO</mat-header-cell
          >
          <!-- <mat-cell *matCellDef="let row"> {{row.dateToShow }}</mat-cell> -->
          <mat-cell *matCellDef="let row">
            {{
              transformDate(row.dateRange.split("-")[0].trim(), row.day)
            }}</mat-cell
          >
        </ng-container>

        <ng-container matColumnDef="paxQuantity">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            PAX
          </mat-header-cell>
          <mat-cell *matCellDef="let row"> {{ row.lstPaX.length }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="nombreServicio">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            SERVICIO
          </mat-header-cell>
          <mat-cell *matCellDef="let row"> {{ row.nombreServicio }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="tipoServicio">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            TIPO SERVICIO
          </mat-header-cell>
          <mat-cell *matCellDef="let row"> {{ row.tipoServicio }} </mat-cell>
        </ng-container>

        <mat-header-row
          *matHeaderRowDef="fileDisplayedColumns"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: fileDisplayedColumns"> </mat-row>
      </mat-table>
    </div>
    <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
  </div>
</ng-template>
